import React, { useState } from "react";
import { CgMenuGridO } from "react-icons/cg";
import { FiMessageSquare } from "react-icons/fi";
import { GoBell } from "react-icons/go";
import { FiLogOut } from "react-icons/fi";
import "./Navbar.css";

const Navbar = ({ title = "Dashboard" }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = () => {
    // optional: call API logout here

    localStorage.clear();
    sessionStorage.clear();

    window.location.replace("/login"); // better than href
  };

  return (
    <div className="top-nav">
      
      {/* LEFT */}
      <div className="top-nav__left">
        <CgMenuGridO size={24} />
        <p className="title">{title}</p>
      </div>

      {/* RIGHT */}
      <div className="top-nav__right">
        
        <div className="icon-btn">
          <FiMessageSquare size={18} />
        </div>

        <div className="icon-btn">
          <GoBell size={18} />
        </div>

        {/* Profile */}
        <div className="profile">
          <img
            src={require("../../Pages/images/trainer-img.webp")}
            alt="profile"
            onClick={() => setShowMenu((prev) => !prev)}
          />

          {/* Dropdown */}
          {showMenu && (
            <div className="profile-menu">
              <button onClick={handleLogout}>
                <FiLogOut /> Logout
              </button>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default Navbar;